import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission } from '../utils/permissions';

export const PermissionRoute = ({ children, permission }) => {
    const { isAuthenticated, loading, user } = useAuth();

    if (loading) {
        return (
            <div className="loading">
                <div>로딩 중...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // 권한이 지정된 경우 권한 확인
    if (permission && !hasPermission(user?.role, permission)) {
        return <Navigate to="/users" replace />; // Admin은 사용자 관리 페이지로 리다이렉트
    }

    return children;
};
